import { useCallback } from 'react';

import { type Clip } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';

export type TrackToggledFavoriteParams = {
  favorited: boolean;
  ids: Clip['id'][];
  location: AirActionTrackingLocation;
};

export const useTrackToggledFavorite = () => {
  const { track } = useAnalyticsUtilities();

  const trackToggledFavorite = useCallback(
    (params: TrackToggledFavoriteParams) => {
      track(`Favorited asset`, params);
    },
    [track],
  );

  return { trackToggledFavorite };
};
